import { useState, useEffect } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";
import * as theme from '../../theme';
import Heading from '../../components/Heading';
import AdditionalContentList from '../../components/dashboards/lists/AdditionalContentList';
import VideoPlayer from '../../components/VideoPlayer';

export default function AdditionalContent() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [activeContent, setActiveContent] = useState(null);

  useEffect(() => {
    if (activeContent) {
      window.scrollTo(0, 0);
    }
  }, [activeContent]);
  
  return (
    <div style={theme.Container.flexColumn}>
      <div style={{ ...theme.Container.flexColumn, marginBottom: 10 }}>
        <Heading title={`Additional Content`} onClick={() => navigate(`/dashboard`)} />
      </div>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          <AdditionalContentList
            currentUser={currentUser}
            setActiveContent={setActiveContent}
          />
        </div>
        <div style={theme.Container.flexTwo}>
          <div style={{ ...theme.Container.flexRow, width: '100%', gap: 20 }}>
            <div style={{ ...theme.Container.flexColumn, flex: 1, gap: 10 }}>
              {activeContent && activeContent.type === 'video' && (
                <>
                  <VideoPlayer videoId={activeContent.title} isPublic={false} />
                  <Heading
                    title={activeContent ? activeContent.title : 'Select Content to View'}
                    subHeading={true}
                    center={true}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}